var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _rect2, _path9, _rect3, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 155,
    viewBox: "0 0 319 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 155,
    fill: "#DBE7DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304 20.5556V18.6162L296 17L288 18.6162V20.5556H304Z",
    stroke: "#14142B",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304 32.1111V29.4445H293.333H288V32.1111H304Z",
    stroke: "#14142B",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.777 22.3334V29.4445",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.555 22.3334V29.4445",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.111 22.3334V29.4445",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M296.889 22.3334V29.4445",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.445 22.3334V29.4445",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M302.223 22.3334V29.4445",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 18.7778,
    r: 0.888889,
    fill: "#14142B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 6.5,
    width: 304,
    height: 140,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93H229V81",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 77,
    width: 64,
    height: 16,
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.876 88.988C244.348 88.988 243.86 88.924 243.412 88.796C242.964 88.668 242.564 88.492 242.212 88.268C241.868 88.044 241.58 87.784 241.348 87.488L242.26 86.408C242.436 86.68 242.664 86.916 242.944 87.116C243.224 87.308 243.54 87.46 243.892 87.572C244.244 87.676 244.604 87.728 244.972 87.728C245.46 87.728 245.844 87.648 246.124 87.488C246.404 87.328 246.544 87.092 246.544 86.78C246.544 86.58 246.464 86.408 246.304 86.264C246.152 86.12 245.884 86.004 245.5 85.916L243.82 85.532C243.372 85.428 242.988 85.284 242.668 85.1C242.348 84.916 242.104 84.692 241.936 84.428C241.776 84.156 241.696 83.844 241.696 83.492C241.696 83.028 241.82 82.616 242.068 82.256C242.324 81.896 242.684 81.608 243.148 81.392C243.62 81.176 244.188 81.068 244.852 81.068C245.548 81.068 246.16 81.188 246.688 81.428C247.216 81.668 247.664 82.024 248.032 82.496L247.168 83.492C246.848 83.084 246.492 82.788 246.1 82.604C245.716 82.412 245.264 82.316 244.744 82.316C244.392 82.316 244.104 82.36 243.88 82.448C243.656 82.528 243.488 82.64 243.376 82.784C243.272 82.928 243.22 83.092 243.22 83.276C243.22 83.42 243.252 83.552 243.316 83.672C243.38 83.784 243.5 83.884 243.676 83.972C243.86 84.06 244.12 84.144 244.456 84.224L245.896 84.548C246.648 84.716 247.188 84.964 247.516 85.292C247.852 85.612 248.02 86.04 248.02 86.576C248.02 87.088 247.888 87.524 247.624 87.884C247.36 88.244 246.988 88.52 246.508 88.712C246.036 88.896 245.492 88.988 244.876 88.988ZM244.312 90.104V79.976H245.428V90.104H244.312Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankConfirmIcon);
export default __webpack_public_path__ + "static/media/BankConfirmIcon.11bf945d433ded9eca67bb413d82ae5b.svg";
export { ForwardRef as ReactComponent };